import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { confirmAlert } from 'react-confirm-alert'

interface ConfirmationAlertProps {
  action: () => void
  title: string
  confirmationMessage: string
  confirmationQuestion: string
  noButtonText?: string
  yesButtonText?: string
  yesButtonColor?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
}

const confirmationAlert = async (props: ConfirmationAlertProps) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <Dialog
          open={true}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={(theme) => ({
              backgroundColor: '#ee000e',
              color: theme.palette.info.contrastText,
            })}
          >
            <Typography variant="h4">{props.title}</Typography>
          </DialogTitle>
          <DialogContent sx={{ marginTop: '20px' }}>
            <Typography>{props.confirmationMessage}</Typography>
            <Typography fontWeight={'bold'}>
              {props.confirmationQuestion}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>{props.noButtonText || 'No'}</Button>
            <Button
              color={props.yesButtonColor || 'primary'}
              variant="contained"
              onClick={() => {
                props.action()
                onClose()
              }}
            >
              {props.yesButtonText || 'Yes'}
            </Button>
          </DialogActions>
        </Dialog>
      )
    },
  })
}

export default confirmationAlert
